import type {
  AddCorrelations,
  Correlations,
  CorrelationsResponse
} from '@library/types/correlations';

export const transformCorrelations = ({
  correlationsData
}: {
  correlationsData: CorrelationsResponse;
}): Correlations =>
  correlationsData?.data.map((correlation) => {
    const {
      id,
      approved_by: approvedBy,
      correlation_id: correlationId,
      created_at: createdAt,
      first_choice: firstChoice,
      first_position: firstPosition,
      first_stat_type: firstStatType,
      is_same_team: isSameTeam,
      last_modified_user_name: lastModifiedUserName,
      probability,
      requested_by: requestedBy,
      second_choice: secondChoice,
      second_position: secondPosition,
      second_stat_type: secondStatType,
      updated_at: updatedAt
    } = correlation;

    return {
      id,
      approvedBy,
      correlationId,
      createdAt,
      firstChoice,
      firstPosition,
      firstStatType,
      rowStatus: undefined,
      isSameTeam,
      isTouched: false,
      lastModifiedUserName,
      probability,
      requestedBy,
      secondChoice,
      secondPosition,
      secondStatType,
      updatedAt
    };
  });

export const getDisableSave = ({
  correlations
}: {
  correlations: AddCorrelations | Correlations;
}) => {
  return correlations.some((correlation) => {
    const {
      approvedBy,
      firstChoice,
      firstPosition,
      firstStatType,
      probability,
      requestedBy,
      secondChoice,
      secondPosition,
      secondStatType
    } = correlation;

    return (
      !approvedBy ||
      !firstChoice ||
      !firstPosition ||
      !firstStatType ||
      !probability ||
      !requestedBy ||
      !secondChoice ||
      !secondPosition ||
      !secondStatType
    );
  });
};
